// @flow

import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'
import imgGPlay from '../../../images/img-gplay.png'
import imgAppStore from '../../../images/img-appstore.png'
import logoBlack from "../../../images/logo-black.svg";
import initializers from '../../../dependencies/initializers'
import _axios from '../../../dependencies/_axios'
import UAParser from 'ua-parser-js'
import { getOSInfo } from '../../../helpers/global'
import $ from 'jquery'
import { withRouter } from "react-router"
import Loader from '../../partials/LoaderNew'

type Props = {
	interviewCode: string
};

class InviteCheckInterviewCode extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleCheckInterviewCode'
		])

		this.state = {
			isMobile: false,
			value_loader:0,
		}

	}

	handleCheckInterviewCode() {
		const { interviewCode, history } = this.props


		const userAgent = navigator.userAgent || navigator.vendor || window.opera

		const parser = new UAParser()
		const isChrome = /chrome/i.test(parser.getBrowser().name)
		const isFirefox = /firefox/i.test(parser.getBrowser().name)
		const isSafari = /safari/i.test(parser.getBrowser().name)
		
		setInterval(() => {
			if (this.state.value_loader <50) {
				this.setState({value_loader:this.state.value_loader+5})
			}
			
		}, 200)
		if (/android/i.test(userAgent)) {
			this.setState({ isMobile: true })
			// window.location = 'astronaut://astrnt.co/code/' + interviewCode

			setTimeout(() => {
				window.location = 'https://play.google.com/store/apps/details?id=co.astrnt.androidqa'
			}, 5000)



		} else if (/ipad|iphone|ipod/i.test(userAgent) && !window.MSStream) {
			this.setState({ isMobile: true })


			setTimeout(() => {
				window.location = 'https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8'
			}, 5000)
			window.location = `astronaut://entercode?code=${interviewCode}`

		} else if (getOSInfo().name == 'Android') {
			//check desktop mode
			this.setState({ isMobile: true })
			// window.location = 'astronaut://astrnt.co/code/' + interviewCode

			setTimeout(() => {
				window.location = 'https://play.google.com/store/apps/details?id=co.astrnt.androidqa'
			}, 5000)

		} else if (getOSInfo().name == 'iOS') {
			//check desktop mode
			this.setState({ isMobile: true })
			// window.location = 'astronaut://astrnt.co/code/' + interviewCode

			setTimeout(() => {
				window.location = 'https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8'
			}, 5000)

		} else {
			let appWeb = initializers.api_host
			if (interviewCode.substr(-3) == '+EU') {
				appWeb = initializers.api_host_eu
			}
			
			_axios({
				url: `${appWeb}/code/${interviewCode}?debug=false`,
				timeout: 200000,
				method: 'get',
				crossdomain: true
			})
			.then((data) => {
				this.setState({value_loader:50})
				this.setState({ isMobile: false })
				let qnaHost = initializers.qna_host
				if(interviewCode.substr(-3) == '+EU') {
					qnaHost = initializers.qna_host_eu
				}
				window.location = qnaHost + '/code/' + interviewCode
			})
			.catch((error) => {
				history.push('/notfound')
				$('.wrapper-entercode').show()
				$('#loader').hide()
				$("#errEnterCode").html("")
			})
		}


	}

	componentDidMount() {
		console.log(getOSInfo())
		this.handleCheckInterviewCode()
	}

	render() {
		const { isMobile,value_loader } = this.state

		return (
			[
				isMobile == false ?
					<Loader value={value_loader} />
					:

					<Fragment>
						<header className="header__unsupported center bg-header-gray">
							<img
								src={logoBlack}
								alt="ASTRNT Q&amp;A"
								className="img-header-unsupported p-0"
							/>
						</header>
						<div className="wrapper-failed">
							<div className="unsupported-content">
								<div>
									<div className="col-md-12">
										<h1 className="bold">Ready to take the interview? Great!</h1>
									</div>
									<div className="col-md-12 m-t-25">
										<h6 className="grey-color-font">
											For your convenience, you can answer the questions in the
											Astronaut mobile app (iOS and Android)
										</h6>
									</div>
									<div className="col-md-12 m-t-20">
										<div className="inline">
											<div className="flex-container flex-center">
												<a
													href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa"
													target="_blank"
													rel="noopener noreferrer"
													className="m-r-8 m-t-8"
												>
													<img src={imgGPlay} className="img-responsive" alt="" />
												</a>
												<a
													href="https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8"
													className="m-r-10"
													target="_blank"
													rel="noopener noreferrer"
													className="m-r-8 m-t-8"
												>
													<img
														src={imgAppStore}
														className="img-responsive"
														alt=""
													/>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Fragment>

			]

		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		interviewCode: ownProps.match.params.interviewCode
	}
}

export default withRouter(connect(mapStateToProps, null)(InviteCheckInterviewCode))
